// To identify users that landed on the quiz/quiz results page from the modals

export const setGoogleOneTapQuizSource = ({
  source,
}: {
  source: 'create_account_modal' | 'log_in_flyout'
}) => sessionStorage.setItem('quiz_entry_source', source)

export const getGoogleOneTapQuizSource = () => {
  const source = sessionStorage.getItem('quiz_entry_source')
  sessionStorage.removeItem('quiz_entry_source')
  return source
}
